;(() => {
  function loadScript(src, callback) {
    const $existingScript = document.querySelector(`script[src='${src}']`)
    if ($existingScript) {
      if (typeof EmblaCarousel !== 'undefined') {
        callback($existingScript)
        return
      }
      $existingScript.addEventListener('load', callback)
      return
    }

    const $script = document.createElement('script')
    $script.src = src
    $script.async = true
    $script.onload = () => callback($script)
    document.head.append($script)
  }

  const onThumbClick = (mainCarousel, thumbCarousel, index) => () => {
    if (!thumbCarousel.clickAllowed()) return
    mainCarousel.scrollTo(index)
  }

  const followMainCarousel = (mainCarousel, thumbCarousel) => () => {
    thumbCarousel.scrollTo(mainCarousel.selectedScrollSnap())
    selectThumbBtn(mainCarousel, thumbCarousel)
  }

  const selectThumbBtn = (mainCarousel, thumbCarousel) => {
    const previous = mainCarousel.previousScrollSnap()
    const selected = mainCarousel.selectedScrollSnap()
    thumbCarousel.slideNodes()[previous].classList.remove('is-selected')
    thumbCarousel.slideNodes()[selected].classList.add('is-selected')
  }

  /**
   * @param {HTMLElement} $embla
   * @param {EmblaCarousel | undefined} mainCarousel
   */
  const initEmblaSlider = ($embla, mainCarousel) => {
    if (Boolean($embla.dataset.initilized) === true) return

    $embla.dataset.initilized = true
    const $vp = $embla.querySelector('.embla__viewport')

    // eslint-disable-next-line no-undef
    const embla = EmblaCarousel($vp, {
      skipSnaps: true,
      containScroll: 'trimSnaps',
      ...(JSON.parse($embla.getAttribute('data-embla-options')) ?? {}),
    })

    // サムネイル対応
    if (mainCarousel) {
      embla.slideNodes().forEach((thumbNode, index) => {
        const onClick = onThumbClick(mainCarousel, embla, index)
        thumbNode.addEventListener('click', onClick, false)
      })

      const syncThumbCarousel = followMainCarousel(mainCarousel, embla)
      mainCarousel.on('select', syncThumbCarousel)
      embla.on('init', syncThumbCarousel)

      // id='productThumbs' の想定
      $embla.addEventListener('updateMedia', (event) => {
        const mediaId = event.detail.media.id
        const $thumb = $embla.querySelector(`[data-media-id="${mediaId}"]`)
        if ($thumb) {
          $thumb.click()
        }
      })
    }

    embla.on('init', () => {
      // Prevent FOUC
      $embla.classList.remove('invisible')
      $embla.classList.add('visible')
    })
    return embla
  }
  loadScript('https://unpkg.com/embla-carousel/embla-carousel.umd.js', () => {
    document.querySelectorAll('.embla-thumb-main').forEach(($embla) => {
      const mainCarousel = initEmblaSlider($embla)
      const $emblaThumb = document.getElementById($embla.dataset.target)
      initEmblaSlider($emblaThumb, mainCarousel)
    })
  })
})()
